var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"banner relative"},[_c('img',{staticClass:"w-max",staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.bannerImg}})]),_c('div',{staticClass:"nav_box"},[(_vm.bannerImg)?_c('sideList',{attrs:{"navList":_vm.navList,"width":"270px","url":"/coreJiShu"},on:{"navBtn":_vm.navBtn}}):_vm._e()],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }